import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import serviceCardimage from '../../../assets/images/home/serviceCardImage/serviceCardImage.png';
import { useNavigate } from 'react-router-dom';

function ServicesCard() {
    const navigate = useNavigate();
    return (
        <div className="home-services-card">
            <div className="home-services-contents">
                <div className="home-services-image-container">
                    <LazyLoadImage
                        draggable={false}
                        src={serviceCardimage}
                        alt="Construction site"
                        effect="blur"
                        width="100%"
                        height="100%"
                        style={{ objectFit: 'cover' }}
                    />
                </div>
                <div className="home-services-description">
                    <h1>WHAT WE OFFER</h1>
                    <p>
                        We offer architectural design, modern and traditional construction, interior styling,
                        renovation, landscaping, and project management—ensuring quality, efficiency, and style in every project.
                    </p>

                    <button
                        className="home-services-learn-more-button"
                        onClick={() => {
                            navigate('/About');
                            window.scrollTo({ top: 0 });
                        }}
                        aria-label="Learn more about us"
                    >
                        Learn More
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ServicesCard